import {FormDefinitionFieldModel} from '../../../field/api/entity/formDefinitionField.model';

export class FormDefinitionFormFieldModel {
    id: number;
    index: number;
    fieldDefinition: FormDefinitionFieldModel;
    label: string;
}
